import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="53.75" height="69.875" viewBox="0 0 53.75 69.875"><path className="a" d="M16.125-67.187V2.688h53.75V-49.467L52.154-67.187ZM21.5-61.812H48.375v16.125H64.5v43h-43Zm32.25,3.779,6.971,6.971H53.75ZM43-40.312,32.25-29.562h8.063v13.438h5.375V-29.562H53.75ZM32.25-13.437v5.375h21.5v-5.375Z" transform="translate(-16.125 67.188)"/></svg>
  )
